import { RefProps } from '@lib/types'
import { TimePicker } from 'antd'
import { TimePickerProps } from 'antd/lib/time-picker'
import cx from 'classnames'
import React from 'react'
import styled from 'styled-components'

type Props = TimePickerProps & RefProps

const StyledTimePicker = React.forwardRef<typeof TimePicker, Props>(
  ({ className = '', ...props }, ref) => (
    <TimeStyledPicker
      // forwardRef={ref}
      className={cx('c-timepicker', className)}
      {...props}
    />
  )
)

const TimeStyledPicker = styled(TimePicker)`
  &.ant-picker {
    border-radius: 4px;
    background-color: ${p => p.theme.datePicker.bg};
    border-color: ${p => p.theme.datePicker.borderColor};
    color: ${p => p.theme.datePicker.color};
    &:hover,
    &:focus {
      border-color: ${p => p.theme.datePicker.hoverAndFocusBorderColor};
    }
    > .ant-picker-input {
      > input::placeholder {
        color: ${p => p.theme.datePicker.placeholderColor};
      }
      > input[disabled] {
        color: ${p => p.theme.datePicker.disabledColor};
      }
      > .ant-picker-clear svg[data-icon='close-circle'] {
        fill: ${p => p.theme.datePicker.clearIconFill};
      }
      > .ant-picker-suffix svg[data-icon='clock-circle'] {
        fill: ${p => p.theme.datePicker.calendarIconFill};
      }
    }
    &.ant-picker-disabled {
      background: ${p => p.theme.datePicker.disabledBg};
    }
  }
`

StyledTimePicker.displayName = 'TimePicker'

export default StyledTimePicker
